/** @jsxImportSource theme-ui */
import { ThemeUIStyleObject } from 'theme-ui';

export const userInfoSectionStyles: Record<string, ThemeUIStyleObject> = {
  // Custom grid layout - not available via Card props
  contentGrid: {
    display: 'grid',
    gridTemplateColumns: ['1fr', '1fr 1fr'],
    gap: '0.25rem',
  },

  // Custom responsive grid column span - not available via built-in props
  fullWidthGridItem: {
    gridColumn: ['1', '1 / -1'],
  },

  // Custom claims section styling - specialized layout not available via component props
  claimsContainer: {
    gridColumn: ['1', '1 / -1'],
    mt: '0.25rem',
  },

  claimsContent: {
    bg: 'b-050',
    p: '0.25rem',
    borderRadius: 'default',
    border: '1px solid',
    borderColor: 'neutral/300',
  },

  claimItem: {
    mb: '0.25rem',
    '&:last-child': { mb: 0 },
  },

  claimKey: {
    fontWeight: 'bold',
    color: 'primary/500',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    display: 'inline-block',
    minWidth: '120px',
    fontSize: 0,
  },

  // Custom info field styling - specialized card-within-card layout
  infoField: {
    p: 3,
    bg: 'b-050',
    borderRadius: 'default',
    border: '1px solid',
    borderColor: 'neutral/300',
  },

  infoFieldLabel: {
    fontWeight: 'bold',
    color: 'neutral/800',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    fontSize: 0,
    mb: 1,
  },
};
